import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { DataBindingDirective } from '@progress/kendo-angular-grid';
import { MessageService } from '@progress/kendo-angular-l10n';
import { CompositeFilterDescriptor, filterBy, process } from '@progress/kendo-data-query';
import { CustomMessagesService } from 'src/app/services/custom-messages.service';
import { images } from 'src/app/resources/images';
import { ApiService } from 'src/app/services/http/api.service';
import { BaseHttpResponse } from 'src/app/models/base-http-response';
import { NotificationService } from '@progress/kendo-angular-notification';
import { User } from 'src/app/global-functions';
import { ExcelExportData } from "@progress/kendo-angular-excel-export";
import { DatePipe } from '@angular/common'
import { FormGroup, FormControl } from '@angular/forms';
import { CostCenter } from 'src/app/models/cost-center.model';
import { Consumption } from 'src/app/models/consumption.model';

@Component({
    selector: 'app-consumption-component',
    templateUrl: './consumption.component.html'
})
export class ConumptionComponent {
    @ViewChild(DataBindingDirective) dataBinding?: DataBindingDirective;
    @ViewChild("container", { read: ViewContainerRef })
    public container: ViewContainerRef | undefined;

    public formGroup: FormGroup = new FormGroup({});

    public gridData: Consumption[] = [];
    public gridView: any[] = [];
    public filter: CompositeFilterDescriptor | undefined;
    public mySelection: string[] = [];
    public listCentroDeCusto: Array<CostCenter> = [];

    public data: Consumption = {
        id: 0,
        refCentroDeCusto: 0,
        nomeCentroDeCusto: "",
        refArtigo: 0,
        nomeArtigo: "",
        codigoInterno: "",
        codigoFabricante: "",
        quantidade: 0,
        codigo: ''
    };
    public customMsgService: CustomMessagesService;
    public centroDeCusto: any;
    public placeHolder: any = {
        nome: "",
        id: undefined,
    };


    constructor(public msgService: MessageService,
        private api: ApiService, private notificationService: NotificationService, private datepipe: DatePipe) {
        this.customMsgService = this.msgService as CustomMessagesService;
        this.allData = this.allData.bind(this);
        this.placeHolder.nome = this.customMsgService.translate('escolherCentroDeCusto');


        this.formGroup = new FormGroup({
            dataDe: new FormControl(),
            dataAte: new FormControl(),
        });
        let hoje = new Date();
        let umaSemanaAtras = new Date(new Date().setDate(new Date().getDate() - 7));

        this.formGroup.controls['dataDe'].setValue(umaSemanaAtras);
        this.formGroup.controls['dataAte'].setValue(hoje);

        let dataDe = this.datepipe.transform(this.formGroup.controls['dataDe'].value, 'yyyy-MM-ddT00:00:00');
        let dataAte = this.datepipe.transform(this.formGroup.controls['dataAte'].value, 'yyyy-MM-ddT23:59:59');
        let uri = "Consumo/GetConsumo?inicio=" + dataDe + "&fim=" + dataAte;


        this.api
            .getRequest<BaseHttpResponse<Consumption[]>>(uri)
            .then((data) => {
                this.gridData = data.value;
                this.gridView = this.gridData;
            })
            .catch(() => { });

        this.api
            .getRequest<BaseHttpResponse<CostCenter[]>>("CentroDeCusto/GetCentrosDeCusto")
            .then((data) => {
                this.listCentroDeCusto = data.value;

            })
            .catch((err) => { });
    }



    public pesquisar(): void {


        let dataDe = this.formGroup.controls['dataDe'].value;
        let dataAte = this.formGroup.controls['dataAte'].value;
        if (dataDe == null || dataAte == null) {
            this.notificationService.show({
                appendTo: this.container,
                content: this.customMsgService.translate('preencherIntervaloDatas'),
                animation: { type: 'slide', duration: 500 },
                position: { horizontal: 'center', vertical: 'top' },
                type: { style: 'error', icon: true },
                hideAfter: 4000
            });
        } else {
            this.loadPesquisa();
        }
    }



    public loadPesquisa() {
        let dataDe = this.datepipe.transform(this.formGroup.controls['dataDe'].value, 'yyyy-MM-ddT00:00:00');
        let dataAte = this.datepipe.transform(this.formGroup.controls['dataAte'].value, 'yyyy-MM-ddT23:59:59');
        let idCentroDeCusto = this.centroDeCusto.id;


        if (idCentroDeCusto == undefined) {
            idCentroDeCusto = 0;
        }

        let endpoint = "Consumo/GetConsumo?idCentroDeCusto=" + idCentroDeCusto + "&inicio=" + dataDe + "&fim=" + dataAte;

        this.api
            .getRequest<BaseHttpResponse<Consumption[]>>(endpoint)
            .then((data) => {
                this.gridData = data.value;
                this.gridView = this.gridData;
            })
            .catch(() => { });
    }


    public onTeamChange(pageSize: number): void {
        pageSize === 25
            ? (this.gridView = this.gridData.slice(pageSize, pageSize * 2))
            : (this.gridView = this.gridData.slice(0, pageSize));
    }

    public onFilter(inputValue: string): void {
        this.gridView = process(this.gridData, {
            filter: {
                logic: 'or',
                filters: [
                    {
                        field: this.getField,
                        operator: 'contains',
                        value: inputValue
                    }
                ]
            }
        }).data;

        this.dataBinding ? this.dataBinding.skip = 0 : null;
    }

    public getField = (args: Consumption) => {
        // var data=  this.datepipe.transform(args.data, 'dd-MM-yyyy HH:mm:ss')
        return `${args.refCentroDeCusto}_${args.nomeCentroDeCusto}_${args.refArtigo}_${args.nomeArtigo}_${args.codigoInterno}_${args.codigoFabricante}_${args.quantidade}`;
    }

    public photoURL(dataItem: any): string {
        const code: string = dataItem.imgId;
        const image: any = images;

        return image[code];
    }

    public flagURL(dataItem: any): string {
        const code: string = dataItem.country;
        const image: any = images;

        return image[code];
    }


    canList() {
        return User.canMovimentosIndustrialVendingList();
    }

    public allData(): ExcelExportData {

        const result: ExcelExportData = {
            data: process(this.gridView, { filter: this.filter }).data,

        };

        return result;
    }

    public filterChange(filter: CompositeFilterDescriptor): void {
        this.filter = filter;
        this.gridData = filterBy(this.gridView, filter);
    }

}
